/** index.html loads upright weights only; the UI also uses italic display/body cuts. Idempotent. */
const HREF = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,500;0,600;0,700;0,800;1,700;1,800&family=Inter:ital,wght@0,400;0,500;0,600;0,700;1,500&family=JetBrains+Mono:wght@400;600&display=swap';

export function ensureFonts(): void {
  if (typeof document === 'undefined' || document.querySelector('link[data-sd-fonts]')) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = HREF;
  link.dataset.sdFonts = '';
  document.head.append(link);
}
